
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import SearchBar from 'components/SearchBar';
import printIcon from 'assets/print.svg';

import styles from './myOrders.module.scss';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { Box } from '@mui/material';
import { useReactToPrint } from 'react-to-print';
import PrintComponentOrderList from '../../../../components/PrintComponent/PrintComponentOrderLIst';


const DesktopOrders = ({ subscription, orders, params, setParams, reorder, navigateToOrder }) => {

  const { restaurant, user } = useSelector((state) => state.auth)
  const componentRef = useRef();
  const [selectMode, setSelectMode] = useState(false);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  //const user = useStore((state) => state.user);
  const options = [10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
  const columns = [
    {
      name: 'Proveedor',
      size: 'large',
    },
    {
      name: 'Estado',
      size: 'medium',
    },
    {
      name: 'Fecha de entrega',
      size: 'medium',
    },
    {
      name: '',
      size: 'small',
    },
  ];


  const toggleOrderSelection = (order) => {
    setSelectedOrders((prevSelected) => {
      const exists = prevSelected.find((o) => o.id === order.id);
      if (exists) {
        return prevSelected.filter((o) => o.id !== order.id);
      } else {
        return [...prevSelected, order];
      }
    });
  };

  return (
    <>
      <div className={styles.desktopOrdersContainer}>
        <div className={styles.row}>
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            p={2}
            width={'100%'}

          >
            <SearchBar
              query={params.query}
              setQuery={(val) => {
                setParams({ ...params, query: val });
              }}
              placeholder="Buscar en Mis Órdenes"
              height="small"
              name="query"
            />

            <Box
              display={'flex'}
            >

              <button
                className={styles.reorder}
                onClick={() => setSelectMode(!selectMode)}
                style={{
                  display: !subscription || subscription.status === 'cancelada' || user.roles[0].name === 'Staff' ? 'none' : null,
                }}
              >
                seleccionar
              </button>
              <Box
                ml={1}
              >
                <button
                  className={styles.printButton}
                  onClick={handlePrint}
                  disabled={selectedOrders.length === 0}
                >
                  <img src={printIcon} alt="printIcon" />
                  <span>Imprimir</span>
                </button>
              </Box>

            </Box>

          </Box>

        </div>
        <div className={`${styles.row} ${styles.headerRow}`}>
          {columns.map((column, i) => {


            return (
              <div
                key={`${i}_${column}`}
                className={`${styles.column} ${styles[column.size]}`}
              >
                {column.name}
              </div>
            );
          })}
        </div>
        {orders.orders.map((order, i) => {
          return (
            <div
              key={`${i}_${order.id}`}
              className={`${styles.row} ${styles.orderRow}`}
              onClick={(e) => {
                navigateToOrder(e, order.code);
              }}
            >
              <div className={`${styles.column} ${styles.large}`}>
                {selectMode && (
                  <input
                    type="checkbox"
                    checked={selectedOrders.some((o) => o.id === order.id)}
                    onClick={(e) => e.stopPropagation()}
                    onChange={() => toggleOrderSelection(order)}
                    style={{ marginRight: 8 }}
                  />
                )}
                {order.supplier.name}
              </div>
              <div className={`${styles.column} ${styles.medium}`}>
                <label className={`${styles.label} ${styles[order.status]}`}>
                  {order.status.charAt(0).toUpperCase() + order.status.slice(1)}{' '}
                </label>
              </div>
              <div className={`${styles.column} ${styles.medium}`}>
                {order.deliveryDate
                  ? moment(order.deliveryDate).format('DD-MM-YYYY')
                  : moment(order.scheduleDate).format('DD-MM-YYYY')}
              </div>
              <div className={`${styles.column} ${styles.small} ${styles.centered}`}>
                <button
                  className={styles.reorder}
                  onClick={() => {
                    reorder(order.code);
                  }}
                  style={{
                    display: !subscription || subscription.status === 'cancelada' || user.roles[0].name === 'Staff' ? 'none' : null,
                  }}
                >
                  Reordenar
                </button>
              </div>
            </div>
          );
        })}

        <PrintComponentOrderList orders={selectedOrders} ref={componentRef} />
      </div>

    </>
  );
};

DesktopOrders.propTypes = {
  orders: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  setParams: PropTypes.func.isRequired,
  reorder: PropTypes.func.isRequired,
  navigateToOrder: PropTypes.func.isRequired,
};

export default DesktopOrders;

